import store from 'store/dist/store.modern'
import type { Environment } from './const/Environment'

const ENV_KEY = 'moia.env'

export const setEnvStore = (env: Environment): void => store.set(ENV_KEY, env)
export const getEnvStore = (): Environment => store.get(ENV_KEY)
